/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const initialState = {
  data: [],
  isLoading: false,
  status: "INITIAL",
};

const EventsReducer = (state = initialState, action) => {
  if (action.type === "EVENTS/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "EVENTS/SUCCESS") {
    return {
      data: action.payload,
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === "EVENTS/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};

const ActivitiesReducer = (state = initialState, action) => {
  if (action.type === "ACTIVITIES/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "ACTIVITIES/SUCCESS") {
    return {
      data: action.payload,
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === "ACTIVITIES/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};

export { EventsReducer, ActivitiesReducer };
